import React, { FC } from "react";
import { TableBuilder } from "kanopi-components/TableView/TableView";
import { useFormatter } from "kw/util/useFormatter";
import { Link } from "kanopi-components/Link";
import { navigate } from "@reach/router";

type TAdminPolicyPeriodsSection = {
  periods: TPolicyPeriod[];
};
export const AdminPolicyPeriodsSection: FC<TAdminPolicyPeriodsSection> = ({
  periods,
}) => {
  const { formatString, formatCurrency, formatDate } = useFormatter();

  const columnSchema = [
    {
      header: "Quote ID",
      id: "quoteId",
      children: (row: TPolicyPeriod) => {
        const quoteId = row.quote.id;
        return (
          <Link
            title={quoteId}
            href={`/admin/quotes/${row.quote.id}`}
            onClick={() => navigate(`/admin/quotes/${quoteId}`)}
          >
            {formatString(quoteId)}
          </Link>
        );
      },
      sortable: false,
    },
    {
      header: "Effective start",
      id: "startDate",
      children: (row: TPolicyPeriod) => formatDate(row.startDate),
      sortable: false,
    },
    {
      header: "Effective end",
      id: "finishDate",
      children: (row: TPolicyPeriod) => formatDate(row.finishDate),
      sortable: false,
    },
    {
      header: "Amount due",
      id: "Amount due",
      children: (row: TPolicyPeriod) => formatCurrency(row.quote.amountDue),
      sortable: false,
    },
  ];
  return (
    <TableBuilder
      columnSchema={columnSchema}
      data={periods}
      showSearchSection={false}
      showPagination={false}
      emptyMessage="No periods found"
      data-testid="tableView-PAYMENT"
    />
  );
};
